module.exports = __webpack_public_path__ + "img/johnoliver5.2d37bd86.jpg";